/* LNM FX – Scroll-Module für die Fertigungsseite (less'n'more). Ohne externe Bibliotheken. */
(function () {
  if (window.LNMFX) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var scrollers = [];
  var ticking = false;
  var lastY = window.scrollY;
  var velocity = 0;

  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function isMobile() { return window.innerWidth < 750; }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      var y = window.scrollY;
      velocity = y - lastY;
      lastY = y;
      var vh = window.innerHeight;
      for (var i = 0; i < scrollers.length; i++) {
        var s = scrollers[i];
        if (!s.el.isConnected) continue;
        var r = s.el.getBoundingClientRect();
        if (r.bottom < -vh || r.top > vh * 2) continue;
        s.fn(r, vh);
      }
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);

  function addScroller(el, fn) {
    scrollers.push({ el: el, fn: fn });
    var r = el.getBoundingClientRect();
    fn(r, window.innerHeight);
  }

  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('is-in');
        if (e.target._fxIn) e.target._fxIn();
        io.unobserve(e.target);
      }
    });
  }, { rootMargin: '0px 0px -12% 0px' }) : null;

  function whenIn(el, cb) {
    if (!io) { el.classList.add('is-in'); cb && cb(); return; }
    if (cb) el._fxIn = cb;
    io.observe(el);
  }

  function splitChars(el, d0) {
    if (el.dataset.fxSplitDone) return;
    el.dataset.fxSplitDone = '1';
    var text = el.textContent;
    el.setAttribute('aria-label', text);
    el.textContent = '';
    var i = 0;
    text.split(/(\s+)/).forEach(function (part) {
      if (/^\s+$/.test(part)) { el.appendChild(document.createTextNode(' ')); return; }
      var word = document.createElement('span');
      word.style.whiteSpace = 'nowrap';
      word.setAttribute('aria-hidden', 'true');
      Array.from(part).forEach(function (ch) {
        var o = document.createElement('span');
        o.className = 'fx-ch';
        var inner = document.createElement('span');
        inner.textContent = ch;
        inner.style.setProperty('--i', i++);
        if (d0) inner.style.setProperty('--d0', d0 + 'ms');
        o.appendChild(inner);
        word.appendChild(o);
      });
      el.appendChild(word);
    });
  }

  /* Odometer: baut Ziffernrollen und dreht sie auf einen Wert */
  function odoBuild(el, value) {
    el.textContent = '';
    el.classList.add('fx-odo');
    el._cols = [];
    String(value).split('').forEach(function (ch, idx) {
      if (!/\d/.test(ch)) {
        var sep = document.createElement('span');
        sep.className = 'fx-odo__sep';
        sep.textContent = ch;
        el.appendChild(sep);
        return;
      }
      var col = document.createElement('span');
      col.className = 'fx-odo__col';
      col.style.setProperty('--i', idx);
      for (var n = 0; n < 10; n++) {
        var s = document.createElement('span');
        s.textContent = n;
        col.appendChild(s);
      }
      el.appendChild(col);
      el._cols.push(col);
    });
  }
  function odoSet(el, value, digits) {
    var str = String(value);
    if (digits) while (str.length < digits) str = '0' + str;
    var ds = str.replace(/\D/g, '').split('');
    if (!el._cols || el._cols.length !== ds.length) odoBuild(el, str);
    el._cols.forEach(function (col, i) {
      col.style.transform = 'translateY(' + (-Number(ds[i])) + 'em)';
    });
  }

  function parallax(inner, frame, from, to) {
    if (reduce) return;
    addScroller(frame, function (r, vh) {
      var p = clamp((vh - r.top) / (vh + r.height), 0, 1);
      inner.style.setProperty('--y', (from + (to - from) * p).toFixed(2) + '%');
    });
  }

  /* ---------- Module ---------- */
  var M = {};

  M.hero = function (root) {
    root.querySelectorAll('[data-fx-split]').forEach(function (el, k) { splitChars(el, k * 260); });
    var imgs = root.querySelectorAll('.fxh__img');
    var idx = 0;
    if (imgs.length) imgs[0].classList.add('is-active');
    requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('is-loaded'); }); });
    if (imgs.length < 2 || reduce) return;
    var ms = parseInt(root.dataset.interval || '1400', 10);
    var z = 1;
    var timer = setInterval(function () {
      if (!root.isConnected) { clearInterval(timer); return; }
      var prev = imgs[idx];
      idx = (idx + 1) % imgs.length;
      var next = imgs[idx];
      imgs.forEach(function (im) { im.classList.remove('is-prev'); });
      prev.classList.remove('is-active');
      prev.classList.add('is-prev');
      next.style.zIndex = ++z;
      next.classList.add('is-active');
      var v = next.querySelector('video');
      if (v) { try { v.currentTime = 0; v.play(); } catch (e) {} }
    }, ms);
  };

  M.pulse = function (root) {
    var cols = root.querySelectorAll('.fxp__col');
    var hls = root.querySelectorAll('.fxp__hl');
    var els = root.querySelectorAll('.fxp__el');
    if (reduce) return;
    addScroller(root, function (r, vh) {
      // 0 wenn Oberkante bei 85 % Höhe, 1 wenn Unterkante des Rasters bei 75 %
      var start = vh * .85, end = vh * .75;
      var total = (start - end) + r.height * .9;
      var p = clamp((start - r.top) / total, 0, 1);
      cols.forEach(function (c, i) {
        var lp = clamp((p - i * .03) / .35, 0, 1);
        c.style.setProperty('--p', lp.toFixed(3));
      });
      hls.forEach(function (h, i) {
        h.style.setProperty('--p', clamp((p - .1 - i * .08) / .3, 0, 1).toFixed(3));
      });
      var n = els.length || 1;
      els.forEach(function (el, i) {
        var t0 = .15 + (i / n) * .6;
        el.style.setProperty('--p', clamp((p - t0) / .18, 0, 1).toFixed(3));
      });
    });
  };

  M.marquee = function (root) {
    var track = root.querySelector('.fxm__track');
    var set = root.querySelector('.fxm__set');
    if (!track || !set) return;
    for (var c = 0; c < 3; c++) {
      var cl = set.cloneNode(true);
      cl.setAttribute('aria-hidden', 'true');
      track.appendChild(cl);
    }
    var speed = parseFloat(root.dataset.speed || '40');
    var dir = root.dataset.dir === 'right' ? 1 : -1;
    var x = 0, drag = false, lastX = 0, v = 0, boost = 0, w = set.offsetWidth, last = performance.now();
    window.addEventListener('resize', function () { w = set.offsetWidth; });
    root.addEventListener('pointerdown', function (e) {
      drag = true; lastX = e.clientX; v = 0;
      root.setPointerCapture && root.setPointerCapture(e.pointerId);
    });
    root.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var dx = e.clientX - lastX;
      lastX = e.clientX;
      x += dx;
      v = dx;
    });
    function up() { drag = false; }
    root.addEventListener('pointerup', up);
    root.addEventListener('pointercancel', up);
    root.addEventListener('pointerleave', up);
    function loop(now) {
      if (!root.isConnected) return;
      var dt = Math.min(64, now - last) / 1000;
      last = now;
      if (!drag) {
        boost += (Math.min(Math.abs(velocity), 40) * .6 - boost) * .1;
        x += dir * (speed + boost * 8) * dt + v;
        v *= .93;
        if (Math.abs(v) < .05) v = 0;
      }
      if (w > 0) { x = x % w; if (x > 0) x -= w; }
      track.style.transform = 'translate3d(' + x.toFixed(2) + 'px,0,0)';
      requestAnimationFrame(loop);
    }
    if (!reduce) requestAnimationFrame(loop);
  };

  M.media = function (root) {
    var frame = root.querySelector('.fxmd__frame');
    var inner = root.querySelector('.fxmd__inner');
    if (frame && inner) parallax(inner, frame, -8, 8);
    var pix = root.querySelector('.fxmd__pix');
    if (!pix || reduce) return;
    var cells = [];
    function build() {
      pix.textContent = '';
      cells = [];
      var cols = parseInt(isMobile() ? root.dataset.colsM : root.dataset.cols, 10) || 25;
      var rows = parseInt(root.dataset.rows, 10) || 4;
      for (var r = 0; r < rows; r++) {
        for (var c = 0; c < cols; c++) {
          var i = document.createElement('i');
          pix.appendChild(i);
          var fromBottom = rows - 1 - r;
          cells.push({ el: i, t: (fromBottom / rows) * .55 + Math.random() * .45 });
        }
      }
    }
    build();
    var mob = isMobile();
    window.addEventListener('resize', function () { if (isMobile() !== mob) { mob = isMobile(); build(); onScroll(); } });
    addScroller(root, function (r, vh) {
      // beginnt, wenn die Unterkante den unteren Rand erreicht
      var p = clamp((vh - r.bottom) / (vh * .55), 0, 1);
      for (var i = 0; i < cells.length; i++) {
        var on = p > cells[i].t * .98 && p > 0;
        if (on !== cells[i].on) { cells[i].on = on; cells[i].el.classList.toggle('on', on); }
      }
    });
  };

  M.tabs = function (root) {
    var tabs = root.querySelectorAll('.fxt__tab');
    var vis = root.querySelectorAll('.fxt__vis');
    var infos = root.querySelectorAll('.fxt__info');
    var cur = 0, z = 2;
    function show(i) {
      if (i === cur) return;
      vis.forEach(function (v) { v.classList.remove('is-prev'); });
      if (vis[cur]) { vis[cur].classList.remove('is-active'); vis[cur].classList.add('is-prev'); }
      if (vis[i]) { vis[i].style.zIndex = ++z; vis[i].classList.add('is-active'); }
      infos.forEach(function (n, k) { n.classList.toggle('is-active', k === i); });
      tabs.forEach(function (t, k) { t.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
      cur = i;
    }
    tabs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
  };

  M.list = function (root) {
    var prev = root.querySelector('.fxl__prev');
    var items = prev ? prev.children : [];
    root.querySelectorAll('.fxl__row').forEach(function (row, i) {
      row.style.setProperty('--i', i);
      whenIn(row);
      if (!prev) return;
      row.addEventListener('mouseenter', function () {
        var k = parseInt(row.dataset.idx, 10);
        Array.prototype.forEach.call(items, function (it, j) { it.classList.toggle('is-active', j === k); });
        prev.classList.toggle('is-on', !!items[k] && items[k].dataset.has === '1');
      });
      row.addEventListener('mouseleave', function () { prev.classList.remove('is-on'); });
    });
    if (prev) {
      var tx = 0, ty = 0, cx = 0, cy = 0;
      root.addEventListener('mousemove', function (e) {
        var r = root.getBoundingClientRect();
        tx = e.clientX - r.left; ty = e.clientY - r.top;
      });
      (function loop() {
        if (!root.isConnected) return;
        cx += (tx - cx) * .14; cy += (ty - cy) * .14;
        prev.style.left = cx + 'px'; prev.style.top = cy + 'px';
        requestAnimationFrame(loop);
      })();
    }
  };

  M.stack = function (root) {
    var cards = Array.prototype.slice.call(root.querySelectorAll('.fxs__card'));
    var n = cards.length;
    var odo = root.querySelector('[data-fx-odo-current]');
    var digits = String(n).length < 2 ? 2 : String(n).length;
    var order = cards.map(function (_, i) { return i; });
    var busy = false;
    function layout() {
      order.forEach(function (ci, depth) {
        var d = Math.min(depth, 3);
        cards[ci].style.setProperty('--d', d);
        cards[ci].setAttribute('data-d', d);
        cards[ci].setAttribute('aria-hidden', depth === 0 ? 'false' : 'true');
      });
      if (odo) odoSet(odo, order[0] + 1, digits);
    }
    function next() {
      if (busy || n < 2) return;
      busy = true;
      var top = cards[order[0]];
      top.classList.add('is-drop');
      order.push(order.shift());
      layout();
      setTimeout(function () {
        top.classList.remove('is-drop');
        busy = false;
      }, reduce ? 0 : 800);
    }
    function prevF() {
      if (busy || n < 2) return;
      busy = true;
      var ci = order.pop();
      order.unshift(ci);
      var c = cards[ci];
      c.classList.add('is-rise');
      void c.offsetWidth;
      layout();
      requestAnimationFrame(function () {
        c.classList.remove('is-rise');
        setTimeout(function () { busy = false; }, reduce ? 0 : 700);
      });
    }
    layout();
    var bn = root.querySelector('[data-fx-next]');
    var bp = root.querySelector('[data-fx-prev]');
    bn && bn.addEventListener('click', next);
    bp && bp.addEventListener('click', prevF);
    var stage = root.querySelector('.fxs__stage');
    if (stage) {
      var sx = null;
      stage.addEventListener('pointerdown', function (e) { sx = e.clientX; });
      stage.addEventListener('pointerup', function (e) {
        if (sx === null) return;
        var dx = e.clientX - sx;
        sx = null;
        if (Math.abs(dx) < 10) next(); else if (dx < 0) next(); else prevF();
      });
    }
  };

  M.videos = function (root) {
    var items = root.querySelectorAll('.fxv__item');
    var vids = root.querySelectorAll('.fxv__vid');
    var frame = root.querySelector('.fxv__frame');
    var cursor = root.querySelector('.fxv__cursor');
    var odo = root.querySelector('[data-fx-odo-current]');
    var cur = -1, muted = true;
    var labelOn = root.dataset.soundOn || 'Ton an', labelOff = root.dataset.soundOff || 'Ton aus';
    function videoOf(i) { return vids[i] ? vids[i].querySelector('video') : null; }
    function show(i) {
      if (i === cur) return;
      var old = videoOf(cur);
      if (old) { try { old.pause(); } catch (e) {} }
      vids.forEach(function (v, k) { v.classList.toggle('is-active', k === i); });
      items.forEach(function (it, k) { it.classList.toggle('is-active', k === i); it.setAttribute('aria-pressed', k === i ? 'true' : 'false'); });
      cur = i;
      var v = videoOf(i);
      if (v) {
        v.muted = muted; v.loop = true; v.playsInline = true;
        if (v.preload === 'none') v.preload = 'auto';
        var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
      }
      if (odo) odoSet(odo, i + 1, 2);
    }
    items.forEach(function (it, i) {
      it.addEventListener('mouseenter', function () { if (!isMobile()) show(i); });
      it.addEventListener('click', function () { show(i); if (isMobile() && frame) frame.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
    });
    if (frame) {
      frame.addEventListener('click', function () {
        muted = !muted;
        var v = videoOf(cur);
        if (v) { v.muted = muted; var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
        if (cursor) cursor.textContent = muted ? labelOn : labelOff;
      });
      if (cursor) {
        frame.addEventListener('mousemove', function (e) {
          var r = frame.getBoundingClientRect();
          cursor.style.left = (e.clientX - r.left) + 'px';
          cursor.style.top = (e.clientY - r.top) + 'px';
        });
      }
    }
    // erst laden, wenn die Sektion in Sicht kommt
    whenIn(root, function () { show(0); });
    // Video pausieren, wenn die Sektion den Bildschirm verlässt
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        en.forEach(function (e) {
          var v = videoOf(cur);
          if (!v) return;
          if (e.isIntersecting) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); } else v.pause();
        });
      }).observe(root);
    }
  };

  /* Fortschritt einer angepinnten Sektion: 0 am Anfang, 1 am Ende */
  function pinProgress(r, vh) {
    var span = r.height - vh;
    return span > 0 ? clamp(-r.top / span, 0, 1) : 0;
  }

  /* In angepinnten Sektionen bewegen sich die Elemente nicht: Einblenden, sobald die Sektion kommt */
  function pinReveal(root) {
    whenIn(root, function () { root.querySelectorAll('[data-fx-reveal]').forEach(function (el) { el.classList.add('is-in'); }); });
  }

  M.pingallery = function (root) {
    var cards = root.querySelectorAll('.fxg__card');
    var n = cards.length;
    if (!n) return;
    var odo = root.querySelector('[data-fx-odo-current]');
    var bar = root.querySelector('.fxg__bar i');
    var cur = -1;
    pinReveal(root);
    function set(i) {
      if (i === cur) return;
      cur = i;
      cards.forEach(function (c, k) { c.classList.toggle('is-on', k <= i); c.classList.toggle('is-active', k === i); });
      if (odo) odoSet(odo, i + 1, 2);
    }
    addScroller(root, function (r, vh) {
      var p = pinProgress(r, vh);
      if (bar) bar.style.transform = 'scaleX(' + p.toFixed(4) + ')';
      set(Math.min(n - 1, Math.floor(p * n)));
    });
  };

  M.pinvideo = function (root) {
    var vids = root.querySelectorAll('.fxf__vid');
    var n = vids.length;
    if (!n) return;
    var pin = root.querySelector('.fxf__pin');
    var titles = root.querySelectorAll('.fxf__t');
    var subs = root.querySelectorAll('.fxf__sub');
    var bars = root.querySelectorAll('.fxf__bar i');
    var odo = root.querySelector('[data-fx-odo-current]');
    var btn = root.querySelector('.fxf__sound');
    var cursor = root.querySelector('.fxf__cursor');
    var labelOn = root.dataset.soundOn || 'Ton an', labelOff = root.dataset.soundOff || 'Ton aus';
    var cur = -1, muted = true, visible = false;
    function videoOf(i) { return vids[i] ? vids[i].querySelector('video') : null; }
    function play(v) {
      if (!v) return;
      v.muted = muted; v.loop = true; v.playsInline = true;
      if (v.preload !== 'auto') v.preload = 'auto';
      var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
    }
    function mark(list, i) {
      list.forEach(function (el, k) { el.classList.toggle('is-active', k === i); el.classList.toggle('is-past', k < i); });
    }
    function set(i) {
      if (i === cur) return;
      var old = videoOf(cur);
      if (old) { try { old.pause(); } catch (e) {} }
      cur = i;
      mark(vids, i); mark(titles, i); mark(subs, i);
      if (odo) odoSet(odo, i + 1, 2);
      if (visible) play(videoOf(i));
      var next = videoOf(i + 1);
      if (next && next.preload === 'none') next.preload = 'metadata';
    }
    function label() {
      var t = muted ? labelOn : labelOff;
      if (btn) { btn.textContent = t; btn.setAttribute('aria-pressed', muted ? 'false' : 'true'); }
      if (cursor) cursor.textContent = t;
    }
    if (pin) {
      pin.addEventListener('click', function () {
        muted = !muted;
        var v = videoOf(cur);
        if (v) { v.muted = muted; play(v); }
        label();
      });
      if (cursor) {
        pin.addEventListener('mousemove', function (e) {
          var r = pin.getBoundingClientRect();
          cursor.style.left = (e.clientX - r.left) + 'px';
          cursor.style.top = (e.clientY - r.top) + 'px';
          pin.classList.add('is-hover');
        });
        pin.addEventListener('mouseleave', function () { pin.classList.remove('is-hover'); });
      }
    }
    addScroller(root, function (r, vh) {
      var f = pinProgress(r, vh) * n;
      bars.forEach(function (b, k) { b.style.transform = 'scaleX(' + clamp(f - k, 0, 1).toFixed(3) + ')'; });
      set(Math.min(n - 1, Math.floor(f)));
    });
    if ('IntersectionObserver' in window) {
      // kurz bevor die Sektion sichtbar wird: aktuelles Video vorladen
      new IntersectionObserver(function (en) {
        en.forEach(function (e) { if (e.isIntersecting) { var v = videoOf(cur); if (v && v.preload !== 'auto') v.preload = 'auto'; } });
      }, { rootMargin: '50% 0px' }).observe(root);
      new IntersectionObserver(function (en) {
        en.forEach(function (e) {
          visible = e.isIntersecting;
          var v = videoOf(cur);
          if (!v) return;
          if (visible) play(v); else v.pause();
        });
      }).observe(root);
    } else { visible = true; play(videoOf(cur)); }
  };

  M.odometer = function (root) {
    var frame = root.querySelector('.fxo__media');
    var inner = root.querySelector('.fxo__media .fxmd__inner');
    if (frame && inner) parallax(inner, frame, -8, 8);
    root.querySelectorAll('[data-fx-odo]').forEach(function (el) {
      var start = el.dataset.start || '0', end = el.dataset.end || '0';
      var digits = Math.max(start.length, end.length);
      odoSet(el, start, digits);
      whenIn(el, function () { setTimeout(function () { odoSet(el, end, digits); }, 200); });
    });
  };

  function init(scope) {
    (scope || document).querySelectorAll('[data-lnmfx]').forEach(function (root) {
      if (root._fxInit) return;
      root._fxInit = true;
      root.classList.add('fx-js');
      root.querySelectorAll('[data-fx-reveal]').forEach(function (el, i) {
        if (!el.style.getPropertyValue('--i')) el.style.setProperty('--i', el.dataset.fxReveal || 0);
        whenIn(el);
      });
      root.querySelectorAll('[data-fx-split-in]').forEach(function (el) { splitChars(el); });
      if (root.querySelector('[data-fx-split-in]')) whenIn(root, function () { root.classList.add('is-loaded'); });
      else if (root.dataset.lnmfx !== 'hero') root.classList.add('is-loaded');
      var fn = M[root.dataset.lnmfx];
      if (fn) { try { fn(root); } catch (e) { console.error('LNMFX', root.dataset.lnmfx, e); } }
    });
    onScroll();
  }

  window.LNMFX = { init: init, odoSet: odoSet };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
